<div class="your-points-container" [ngClass]="{'your-points-container--up': isEnrolled || isClientNotEnrolled, 'your-points-container--overlap': !isClientNotEnrolled && !isEnrolled}">
  <!-- Overlay de login para todos los casos donde isLoggedIn = false -->
  <div *ngIf="!isLoggedIn" class="your-points-login-overlay">
    <div class="your-points-login-content">
      <div class="your-points-login-row">
        <img [src]="'images/ifood-landing/points-lock.svg' | assetsUrl" alt="Lock" class="your-points-login-lock" />
        <span class="your-points-login-text">Entre para ver seus pontos</span>
      </div>
      <button class="your-points-login-btn" (click)="onLoginClick()">Fazer login</button>
    </div>
  </div>
  <div class="your-points-header-inline">
    <div class="your-points-title">Seus pontos</div>
    <div class="your-points-cashbacks">
      <div *ngIf="showClubeEnrolledCashback">
        <div class="your-points-cashback-old">
          <span class="your-points-cashback-new your-points-cashback-new--no-clube your-points-cashback-link" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">2% de cashback</span>
          <img [src]="'images/ifood-landing/info-circle-filled.svg' | assetsUrl" alt="info" class="your-points-info-icon" />
        </div>
        <div class="your-points-cashback-new-row">
          <img [src]="'images/ifood-landing/cashback-icon.svg' | assetsUrl" alt="cashback" class="your-points-cashback-icon" />
          <span class="your-points-cashback-new your-points-cashback-link" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">5% de cashback</span>
        </div>
      </div>
      <div *ngIf="showNoClubeEnrolledCashback" class="your-points-cashback-new-row">
        <img [src]="'images/ifood-landing/refund-points.svg' | assetsUrl" alt="cashback gris" class="your-points-cashback-icon" />
        <span class="your-points-cashback-new your-points-cashback-new--no-clube your-points-cashback-link" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">2% de cashback</span>
        <img [src]="'images/ifood-landing/info-circle-filled.svg' | assetsUrl" alt="info" class="your-points-info-icon" />
      </div>
      <div *ngIf="showClubeNotEnrolledNotClientCashback" class="your-points-cashbacks">
        <div class="your-points-cashback-old">
          <span class="your-points-cashback-new your-points-cashback-new--no-clube your-points-cashback-link" style="text-decoration: line-through;" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">2% de cashback</span>
          <img [src]="'images/ifood-landing/info-circle-filled.svg' | assetsUrl" alt="info" class="your-points-info-icon" />
        </div>
        <div class="your-points-cashback-new-row">
          <img [src]="'images/ifood-landing/cashback-lock.svg' | assetsUrl" alt="cashback lock" class="your-points-cashback-icon" />
          <span class="your-points-cashback-new your-points-cashback-new--no-clube your-points-cashback-link your-points-cashback-new--locked" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">5% de cashback</span>
        </div>
      </div>
      <div *ngIf="showNoClubeNotEnrolledNotClientCashback" class="your-points-cashbacks">
        <div class="your-points-cashback-new-row">
          <img [src]="'images/ifood-landing/cashback-lock.svg' | assetsUrl" alt="cashback lock" class="your-points-cashback-icon" />
          <span class="your-points-cashback-new your-points-cashback-new--no-clube your-points-cashback-link" role="button" tabindex="0" (click)="openCashbackInfoModal()" (keyup.enter)="openCashbackInfoModal()">2% de cashback</span>
          <img [src]="'images/ifood-landing/info-circle-filled.svg' | assetsUrl" alt="info" class="your-points-info-icon" />
        </div>
      </div>
    </div>
  </div>
  <div class="your-points-row">
    <span class="your-points-icon">
      <img [src]="'images/ifood-landing/loyalty-filled.svg' | assetsUrl" alt="Loyalty" width="24" height="24" />
    </span>
    <span class="your-points-value">{{ formattedPoints || '—' }}</span>
  </div>
</div>

<!-- Modal cashback info -->
<al-modal
  class="ifood-bottom-sheet"
  [show]="showCashbackInfoModal"
  [footerDivider]="false"
  [hideClose]="true"
  (closed)="closeCashbackInfoModal()"
>
  <div
    slot="content"
    class="your-points-info-modal-content"
    (touchstart)="modalTouchStart($event)"
    (touchmove)="modalTouchMove($event)"
    (touchend)="modalTouchEnd()"
  >
    <div class="your-points-modal-title-bar your-points-modal-title-bar--custom"></div>
    <div class="your-points-info-title">Como funciona a parceria</div>
    <div class="your-points-info-text">
      <p>A cada pedido que fizer no iFood, <strong>você recebe parte do valor de volta em forma de pontos Decolar.</strong>
        Use em suas próximas viagens.</p>
    </div>
    <div class="your-points-info-divider"></div>
    <div class="your-points-info-step">
      <div class="your-points-info-step-circle">
        <span class="your-points-info-step-number">1</span>
      </div>
      <span class="your-points-info-step-text">Faça um pedido no iFood</span>
    </div>
    <div class="your-points-info-step">
      <div class="your-points-info-step-circle">
        <span class="your-points-info-step-number">2</span>
      </div>
      <span class="your-points-info-step-text">Receba parte do valor de volta, em forma de pontos Decolar</span>
    </div>
    <div class="your-points-club-section">
      <span class="your-points-club-section-text">Receba 2% de volta sem</span>
      <img class="your-points-club-section-logo" [src]="'images/ifood-landing/clube_ifood_gris.svg' | assetsUrl" alt="Clube iFood gray" />
    </div>
    <div class="your-points-club-section-5">
      <span class="your-points-club-section-5-text">ou receba 5% de volta</span>
      <span class="your-points-club-section-5-with">com</span>
      <img class="your-points-club-section-5-logo" [src]="'images/ifood-landing/clube_ifood_color.svg' | assetsUrl" alt="Clube iFood color" />
    </div>
    <div class="your-points-info-divider"></div>
    <div class="your-points-modal-earn-points-text">
      Acumular pontos é muito fácil!
    </div>
    <div class="your-points-modal-earn-points-row">
      <img [src]="'images/ifood-landing/thumbs-up.svg' | assetsUrl" alt="Thumbs up" class="your-points-modal-earn-points-icon" />
      <span class="your-points-modal-earn-points-row-text">Clique em Conectar minha conta iFood</span>
    </div>
    <div class="your-points-modal-earn-points-row">
      <img [src]="'images/ifood-landing/faca-login.svg' | assetsUrl" alt="Login" class="your-points-modal-earn-points-icon" />
      <span class="your-points-modal-earn-points-row-text">Faça login na Decolar</span>
    </div>
    <div class="your-points-modal-earn-points-row">
      <img [src]="'images/ifood-landing/checkmark-circle.svg' | assetsUrl" alt="Checkmark circle" class="your-points-modal-earn-points-icon" />
      <span class="your-points-modal-earn-points-row-text">Pronto! Seus pedidos viram pontos</span>
    </div>
    <div class="your-points-info-divider"></div>
    <div *ngIf="!isEnrolled">
      <button class="your-points-connect-partnership" (click)="onParceriaConnectIfoodClick()">Conectar minha conta iFood</button>
    </div>
    <div *ngIf="isEnrolled">
      <button class="your-points-understood" (click)="onParceriaEntendiClick()">Entendi</button>
    </div>
  </div>
</al-modal>
